<template>
    <div>
        <button type="button" @click="increment('sxs','ppp')">Button</button>
        {{i}}
    </div>
</template>
<script>
import _ from 'lodash';
export default {
    data( ) {
        return {
            i: 0,
            timer: 0,
        }
    },
    created() {
        // this.increment = _.debounce(function(){}, 1000);
    },
    methods : {
        increment: _.debounce(function(val1, val2 ) {
            this.incrementI(val1, val2);
        },500),
        incrementI(val1,val2) {
            console.log(val1, val2)
            this.i++;
        }
    }
}
</script>